<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/banner-center-zh.png'"
        :alt="$t('langs.aolei')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/banner-center-en.png'"
        :alt="$t('langs.aolei')"
      />
    </div>
    <div class="box_center_pd">
      <span class="text_pd">{{ $t("langs.energystoragebattery") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line"></span>
    </div>
    <div class="center_center">
      <span class="main_word_center">{{
        $t("langs.energystoragebatterybox")
      }}</span>
    </div>
    <div class="center_center">
      <div class="main_images">
          <img :src="this.$path + '/assets/images/main_power.png'" />
          <img :src="this.$path + '/assets/images/main_power_one.png'" />
          <img :src="this.$path + '/assets/images/main_power_two.png'" />
      </div>
    </div>
    <div class="box_center_pd">
      <span class="text_pd">{{ $t("langs.features") }}</span>
    </div>
    <div class="row_line">
      <span class="td_line"></span>
    </div>
    <div class="center_center_memo">
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/more_power.png'"
          />
          <span class="info_title_center">{{ $t("langs.moreavailable") }}</span>
          <span class="info_memo_center">{{ $t("langs.discharge") }}</span>
          <span class="info_memo_center">{{ $t("langs.optimization") }}</span>
        </div>
      </div>
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/live.png'"
          />
          <span class="info_title_center">{{ $t("langs.flexible") }}</span>
          <span class="info_memo_center">{{ $t("langs.modulardesign") }}</span>
          <span class="info_memo_center">{{ $t("langs.flexibleexpansion") }}</span>
        </div>
      </div>
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/soft.png'"
          />
          <span class="info_title_center">{{ $t("langs.reliable") }}</span>
          <span class="info_memo_center">{{ $t("langs.lithium") }}</span>
        </div>
      </div>
    </div>
    <div class="center_center_memo">
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/setup.png'"
          />
          <span class="info_title_center">{{ $t("langs.installation") }}</span>
          <span class="info_memo_center">{{ $t("langs.powermodule") }}</span>
          <span class="info_memo_center">{{ $t("langs.batterymodule") }}</span>
        </div>
      </div>
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/open.png'"
          />
          <span class="info_title_center">{{ $t("langs.perfectly") }}</span>
          <span class="info_memo_center">{{ $t("langs.multiphaseinverters") }}</span>
        </div>
      </div>
      <div class="layer_center flex-col_center">
        <div class="mode_block_center flex-col_center">
          <img
            referrerpolicy="no-referrer"
            :src="this.$path + '/assets/images/nice.png'"
          />
          <span class="info_title_center">{{ $t("langs.quickstart") }}</span>
          <span class="info_memo_center">{{ $t("langs.automatic") }}</span>
        </div>
      </div>
    </div>
    <div class="box_center_pd">
      <span class="text_pd">{{ $t("langs.parameter") }}</span>
      <div class="row_line">
        <span class="td_line"></span>
      </div>
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/power-parameter-table-zh.png'"
        style="margin-top: 3%"
        :alt="$t('langs.parameter')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/power-parameter-table-en.png'"
        style="margin-top: 3%"
        :alt="$t('langs.parameter')"
      />
    </div>
    <Footer></Footer>
    <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from '../components/hover';


export default {
  name: "centerpower",
  components: { Head, Footer,Hover },
};
</script>

<style>
@import "../assets/css/center.css";
.flex-col_center {
  display: flex;
  flex-direction: column;
}

.center_center_memo {
  width: auto;
  display: flex;
  margin-top: 20px;
  padding: 0px 15%;
}

.layer_center {
  z-index: 115;
  height: 170px;
  background-color: rgba(216, 216, 216, 0);
  width: 340px;
  justify-content: center;
  align-items: center;
}

.info_title_center {
  z-index: 121;
  width: auto;
  height: 25px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  white-space: nowrap;
  line-height: 25px;
  text-align: center;
  margin-top: 12px;
}

.info_memo_center {
  z-index: 123;
  width: auto;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 170, 170, 1);
  font-size: 14px;
  white-space: nowrap;
  line-height: 20px;
  text-align: center;
  margin-top: 4px;
}

.mode_block_center {
  z-index: auto;
  width: 100%;
  height: 123px;
  align-items: center;
  justify-items: center;
  text-align: center;
  display: block;
}

.mode_block_center img {
  z-index: 116;
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/center_power.vue